<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" [ngClass]="backgroundTitleCls">
    <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="ps-1">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav #navContainer class="d-none d-lg-flex me-auto" style="flex-wrap: nowrap;">
      <c-nav-item *ngFor="let menuItem of headerNavItems; let i = index"
                  #navItemEl
                  [class.d-none]="i >= visibleItemCount">
        <a cNavLink [routerLink]="menuItem.url" routerLinkActive="active">
          {{ menuItem.name }}
        </a>
      </c-nav-item>

      <!-- Dropdown "Mais" -->
      <c-nav-item *ngIf="overflowNavItems.length > 0">
        <c-dropdown variant="nav-item" alignment="start">
          <a cNavLink cDropdownToggle>Mais</a>
          <ul cDropdownMenu>
            <li *ngFor="let item of overflowNavItems">
              <a [routerLink]="item.url" cDropdownItem>{{ item.name }}</a>
            </li>
          </ul>
        </c-dropdown>
      </c-nav-item>

      <!-- Gerenciar atalhos -->
      <c-nav-item class="align-content-center">
        <c-dropdown alignment="start" variant="nav-item" (visibleChange)="onFavDropdownOpenChange($event)">
          <button cButton color="" [caret]="false" cDropdownToggle class="py-0 px-2" title="Gerenciar atalhos">
            <svg cIcon name="cilStar" size="lg" style="opacity: 0.35;"></svg>
          </button>
          <div cDropdownMenu class="pt-0" style="min-width: 280px;">
            <h6 cDropdownHeader class="bg-light fw-semibold py-2">Gerenciar Atalhos</h6>
            <div class="px-3 py-2">
              <input type="text" class="form-control form-control-sm" placeholder="Buscar..."
                [(ngModel)]="favSearchTerm" (ngModelChange)="filterNavItems()"
                (click)="$event.stopPropagation()">
            </div>
            <div style="max-height: 300px; overflow-y: auto;">
              <a *ngFor="let item of filteredNavItems"
                 class="dropdown-item d-flex align-items-center py-2"
                 style="cursor: pointer;"
                 (click)="toggleFavorite(item, $event)">
                <svg cIcon class="me-2 flex-shrink-0"
                  name="cilStar"
                  [ngClass]="{'text-warning': isFavorite(item.nav_item_id)}"
                  size="sm"></svg>
                <span class="text-truncate">{{ item.breadcrumb }}</span>
              </a>
              <div *ngIf="filteredNavItems.length === 0" class="dropdown-item text-muted text-center">
                Nenhum item encontrado
              </div>
            </div>
          </div>
        </c-dropdown>
      </c-nav-item>
    </c-header-nav>

    <c-header-nav class="d-none d-lg-flex">
      <!-- Tarefas -->
      <app-task-status-notification></app-task-status-notification>
    </c-header-nav>

    <app-support-button></app-support-button>

    <!-- Ícone de atualização disponível (visível em TODOS os tamanhos de tela) -->
    <c-header-nav *ngIf="updater.isNewVersionAvailable" class="ms-2">
      <c-nav-item>
        <a class="text-success" routerLink="./" cNavLink title="Há uma atualização disponível! Clique para atualizar." (click)="applyUpdate()">
          <svg cIcon name="cilCloudDownload" size="lg"></svg>
        </a>
      </c-nav-item>
    </c-header-nav>

    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>

  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
  </c-container>
</ng-container>
<!--</c-header>-->

<!-- Aviso de expiração de sessão por inatividade -->
<div *ngIf="showLogoutWarning" class="session-warning-backdrop">
  <div class="session-warning-modal">
    <h5 class="mb-2">
      <svg cIcon name="cilWarning" size="lg" class="text-warning me-2"></svg>
      Sua sessão vai expirar
    </h5>
    <p class="mb-3">
      Por inatividade, você será desconectado em
      <strong>{{ warningSecondsLeft }}</strong> segundo(s).
    </p>
    <div class="d-flex justify-content-end gap-2">
      <button cButton color="secondary" variant="outline" (click)="logout()">
        Sair agora
      </button>
      <button cButton color="primary" (click)="continuarConectado()">
        Continuar conectado
      </button>
    </div>
  </div>
</div>

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button cButton color="" [caret]="false" cDropdownToggle class="py-0">
      <c-avatar cTextColor="primary" shape="rounded-1" size="md" src="assets/img/avatars/photo-user.png"
        status="success">
      </c-avatar>
      <span class="m-2 d-none d-sm-none d-md-none d-lg-inline">{{ userName }}</span>
    </button>
    <ul cDropdownMenu class="pt-0 ">
      <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2">Configurações</h6>
      </li>
      <li></li>
      <li>
        <a routerLink="/configuracao/usuario/perfil" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg>
          Perfil
        </a>
      </li>
      <li>
        <a routerLink="/tasks" cDropdownItem>
          <svg cIcon class="me-2" name="cilBell"></svg>
          Tarefas do Servidor
        </a>
      </li>
      <li>
        <a routerLink="/utilitarios" cDropdownItem>
          <svg cIcon class="me-2" name="cilCloudDownload"></svg>
          Utilitários
        </a>
      </li>
      <li>
        <a routerLink="/configuracao" cDropdownItem>
          <svg cIcon class="me-2" name="cilSettings"></svg>
          Configurações
        </a>
      </li>
      <li *ngFor="let action of dropdownMenuActions">
        <a class="click" (click)="action.action()" cDropdownItem>
          <svg cIcon class="me-2" name="{{ action.icon }}"></svg>
          {{ action.label }}
        </a>
      </li>
      <li *ngIf="sync">
        <a class="click" (click)="sync()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLoopCircular"></svg>
          Sincronizar
        </a>
      </li>
      <li *ngIf="updater.isNewVersionAvailable">
        <hr cDropdownDivider />
      </li>
      <li *ngIf="updater.isNewVersionAvailable">
        <a class="click text-success" (click)="applyUpdate()" cDropdownItem>
          <svg cIcon class="me-2" name="cilCloudDownload"></svg>
          Atualizar agora
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a class="click" (click)="logout()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg>
          Sair
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a class="click text-center p-0" style="font-size: 0.775rem;" (click)="checkForUpdate()" cDropdownItem>
          <small>
            <svg *ngIf="updater.isChecking" cIcon class="me-1 spinner-icon" name="cilSync" size="sm"></svg>
            Versão: {{ appVersion }}
          </small>
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>
